import { render, staticRenderFns } from "./WeeklyPlanAddItem.vue?vue&type=template&id=6a4e9610&scoped=true&"
import script from "./WeeklyPlanAddItem.vue?vue&type=script&lang=js&"
export * from "./WeeklyPlanAddItem.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPlanAddItem.vue?vue&type=style&index=0&id=6a4e9610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e9610",
  null
  
)

export default component.exports